import script from "./LatestComments.vue?vue&type=script&setup=true&lang=js"
export * from "./LatestComments.vue?vue&type=script&setup=true&lang=js"

import "./LatestComments.vue?vue&type=style&index=0&id=4ee5802a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ee5802a"]])

export default __exports__